import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { clearCustomRequest, customRequestApis, } from "../../../store/customRequest/actions";
import { INSURANCES_DELETE_ENTITY_CAMPAIGN, INSURANCES_DELETE_ENTITY_PROJECT, } from "../constants/insurances.constants";
var PROJECT_REQUEST_KEY = "deleteInsuranceProject";
var CAMPAIGN_REQUEST_KEY = "deleteInsuranceCampaign";
export var useDeleteInsuranceProduct = function () {
    var dispatch = useDispatch();
    var projectResponse = useSelector(function (state) { var _a, _b, _c; return (_c = (_b = (_a = state.CustomRequest) === null || _a === void 0 ? void 0 : _a.dataCustomRequest) === null || _b === void 0 ? void 0 : _b[PROJECT_REQUEST_KEY]) !== null && _c !== void 0 ? _c : null; });
    var loadingProject = useSelector(function (state) { var _a, _b, _c; return (_c = (_b = (_a = state.CustomRequest) === null || _a === void 0 ? void 0 : _a.loadingCustomRequest) === null || _b === void 0 ? void 0 : _b[PROJECT_REQUEST_KEY]) !== null && _c !== void 0 ? _c : false; });
    var errorProject = useSelector(function (state) { var _a, _b, _c; return (_c = (_b = (_a = state.CustomRequest) === null || _a === void 0 ? void 0 : _a.errorCustomRequest) === null || _b === void 0 ? void 0 : _b[PROJECT_REQUEST_KEY]) !== null && _c !== void 0 ? _c : null; });
    var loadingCampaign = useSelector(function (state) {
        var _a, _b, _c;
        return (_c = (_b = (_a = state.CustomRequest) === null || _a === void 0 ? void 0 : _a.loadingCustomRequest) === null || _b === void 0 ? void 0 : _b[CAMPAIGN_REQUEST_KEY]) !== null && _c !== void 0 ? _c : false;
    });
    var errorCampaign = useSelector(function (state) { var _a, _b, _c; return (_c = (_b = (_a = state.CustomRequest) === null || _a === void 0 ? void 0 : _a.errorCustomRequest) === null || _b === void 0 ? void 0 : _b[CAMPAIGN_REQUEST_KEY]) !== null && _c !== void 0 ? _c : null; });
    var dispatchDelete = function (requestKey, entity, id, userId) {
        dispatch(customRequestApis({
            requestKey: requestKey,
            method: "PATCH",
            path: "/asg/Api/V1/delete/".concat(entity, "/").concat(id, "/user-mod/").concat(userId),
        }));
    };
    var deleteProduct = function (_a) {
        var projectId = _a.projectId, campaignId = _a.campaignId, userId = _a.userId;
        if (campaignId) {
            dispatchDelete(CAMPAIGN_REQUEST_KEY, INSURANCES_DELETE_ENTITY_CAMPAIGN, campaignId, userId);
        }
        dispatchDelete(PROJECT_REQUEST_KEY, INSURANCES_DELETE_ENTITY_PROJECT, projectId, userId);
    };
    var clearDelete = function () {
        dispatch(clearCustomRequest(PROJECT_REQUEST_KEY));
        dispatch(clearCustomRequest(CAMPAIGN_REQUEST_KEY));
    };
    useEffect(function () {
        return function () {
            dispatch(clearCustomRequest(PROJECT_REQUEST_KEY));
            dispatch(clearCustomRequest(CAMPAIGN_REQUEST_KEY));
        };
    }, []);
    return {
        deleteProduct: deleteProduct,
        productDeleted: projectResponse !== null,
        loadingDelete: loadingProject || loadingCampaign,
        errorDelete: errorProject !== null && errorProject !== void 0 ? errorProject : errorCampaign,
        clearDelete: clearDelete,
    };
};
